import React from 'react';

import {
  SHIMMER_CONTEXT_ROW_COUNT,
  SHIMMER_STAT_COUNT,
  SHIMMER_ASSESSMENT_ROW_COUNT,
} from '../constants';
import {
  Section,
  SectionLabel,
  StatsRow,
  AssessmentList,
  ShimmerBlock,
  ShimmerCard,
  ShimmerStat,
  ShimmerRow,
  ShimmerTagGroup,
} from '../styles';

const LoadingSkeleton = () => (
  <>
    <Section>
      <SectionLabel>
        <ShimmerBlock width="120px" height="12px" />
      </SectionLabel>
      <ShimmerCard>
        {Array.from({ length: SHIMMER_CONTEXT_ROW_COUNT }).map((_, idx) => (
          <ShimmerBlock key={idx} width={idx % 2 ? '70%' : '85%'} height="14px" />
        ))}
      </ShimmerCard>
    </Section>

    <StatsRow>
      {Array.from({ length: SHIMMER_STAT_COUNT }).map((_, idx) => (
        <ShimmerStat key={idx}>
          <ShimmerBlock width="60%" height="12px" />
          <ShimmerBlock width="40%" height="22px" />
        </ShimmerStat>
      ))}
    </StatsRow>

    <AssessmentList>
      {Array.from({ length: SHIMMER_ASSESSMENT_ROW_COUNT }).map((_, idx) => (
        <ShimmerRow key={idx}>
          <ShimmerBlock width="22px" height="22px" />
          <ShimmerBlock width="55%" height="14px" />
          <ShimmerTagGroup>
            <ShimmerBlock width="70px" height="22px" />
            <ShimmerBlock width="60px" height="22px" />
            <ShimmerBlock width="50px" height="22px" />
            <ShimmerBlock width="20px" height="22px" />
          </ShimmerTagGroup>
        </ShimmerRow>
      ))}
    </AssessmentList>
  </>
);

export default LoadingSkeleton;
